import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var defaultProps = {
  designSystem: 'atria',
  includeFinishLater: true,
  includeQuestionNumber: false,
  toolbarPlacement: 'top',
  disableGutters: true
};
var styleOverrides = {
  root: function root(_ref) {
    var theme = _ref.theme;
    return _defineProperty({
      overflow: 'auto',
      '& > form': {
        backgroundColor: theme.palette.background["default"],
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& .LumaFormQuestion': {
          flex: 1,
          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(4),
          display: 'flex',
          justifyContent: 'center',
          '& .LumaFormQuestionPaper': {
            maxHeight: 'fit-content',
            minWidth: theme.breakpoints.values.sm,
            maxWidth: theme.breakpoints.values.sm,
            '& .LumaFormQuestionToolbar': {
              '& .MuiToolbar-root': {
                height: 80
              },
              '& .MuiLinearProgress-root': {
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2)
              }
            },
            '& .LumaFormQuestionContent': {
              padding: theme.spacing(5)
            },
            '& .LumaFormQuestionActions': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 6
            }
          }
        }
      }
    }, theme.breakpoints.down('md'), {
      '& > form': {
        '& .LumaFormQuestion': {
          padding: 0,
          '& .LumaFormQuestionPaper': {
            minWidth: '100%',
            minHeight: '100%',
            maxHeight: 'none'
          }
        }
      }
    });
  }
};
export default {
  defaultProps: defaultProps,
  styleOverrides: styleOverrides
};